import { Select } from "antd";
import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";

interface IProps {
  counselGBN: string|undefined;
  setCounselGBN: (counselGBN: string) => void;
}

const SelectCounselType: FC<IProps> = ({
  counselGBN,
  setCounselGBN,
}) => {
  const { t } = useTranslation();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // MB0008 = 상담구분
  const MB0008 = commonCodes.find(item => item.commonCode === 'MB0008')?.detailCode;

  return (
    <Select
      className="w-100"
      placeholder={t('student.student.column34')}
      value={counselGBN}
      onChange={value => setCounselGBN(value)}
    >
      <Select.Option value="">{t('common.text.all')}</Select.Option>
      {MB0008?.map((item) => (
        <Select.Option
          key={item.detailCode}
          value={item.detailCode}
        >
          {item.korName}
        </Select.Option>
      ))}
    </Select>
  );
}

export default SelectCounselType;
